import { supabase } from '@/integrations/supabase/client';

/**
 * Load volume_multiplier for each child bot from bot_merge_mapping
 * Returns Map<childBotId, volume_multiplier>
 * Defaults to 1.0 if not set
 */
export async function loadVolumeMultipliers(
  parentBotId: string
): Promise<Map<string, number>> {
  const volumeMultiplierMap = new Map<string, number>();
  
  try {
    const { data: mappings } = await supabase
      .from('bot_merge_mapping')
      .select('child_bot_id, volume_multiplier')
      .eq('parent_bot_id', parentBotId)
      .eq('is_active', true);
    
    mappings?.forEach(m => {
      // Default to 1.0 if not set
      volumeMultiplierMap.set(m.child_bot_id, m.volume_multiplier ?? 1.0);
    });
    
    console.log('Loaded volume multipliers:', Object.fromEntries(volumeMultiplierMap));
  } catch (error) {
    console.error('Error loading volume multipliers:', error);
  }
  
  return volumeMultiplierMap;
}
